import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-16-layer-blur.tsx
/**
* icon.16.layer.blur
*
* dots, scatter, blur, layer, disperse, spread, particles
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTMuNSAxMmEuNS41IDAgMSAxIDAgMSAuNS41IDAgMCAxIDAtMW0zIDBhLjUuNSAwIDEgMSAwIDEgLjUuNSAwIDAgMSAwLTFtMyAwYS41LjUgMCAxIDEgMCAxIC41LjUgMCAwIDEgMC0xbTMgMGEuNS41IDAgMSAxIDAgMSAuNS41IDAgMCAxIDAtMW0tNi0zLjVhMSAxIDAgMSAxIDAgMiAxIDEgMCAwIDEgMC0ybTMgMGExIDEgMCAxIDEgMCAyIDEgMSAwIDAgMSAwLTJtLTYgLjVhLjUuNSAwIDEgMSAwIDEgLjUuNSAwIDAgMSAwLTFtOSAwYS41LjUgMCAxIDEgMCAxIC41LjUgMCAwIDEgMC0xbS02LTMuNWExIDEgMCAxIDEgMCAyIDEgMSAwIDAgMSAwLTJtMyAwYTEgMSAwIDEgMSAwIDIgMSAxIDAgMCAxIDAtMm0tNiAuNWEuNS41IDAgMSAxIDAgMSAuNS41IDAgMCAxIDAtMW05IDBhLjUuNSAwIDEgMSAwIDEgLjUuNSAwIDAgMSAwLTFtLTktM2EuNS41IDAgMSAxIDAgMSAuNS41IDAgMCAxIDAtMW0zIDBhLjUuNSAwIDEgMSAwIDEgLjUuNSAwIDAgMSAwLTFtMyAwYS41LjUgMCAxIDEgMCAxIC41LjUgMCAwIDEgMC0xbTMgMGEuNS41IDAgMSAxIDAgMSAuNS41IDAgMCAxIDAtMSIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=20729-52963
*/
const Icon16LayerBlur = memo(function Icon16LayerBlur(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "16",
		height: "16",
		fill: "none",
		viewBox: "0 0 16 16",
		...props,
		"data-fpl-icon-size": "16",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M3.5 12a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m3 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m3 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m3 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m-6-3.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-6 .5a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m9 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m-6-3.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-6 .5a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m9 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m-9-3a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m3 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m3 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m3 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1"
		})
	});
});
//#endregion
export { Icon16LayerBlur };

//# sourceMappingURL=icon-16-layer-blur.js.map